import './components/business/library/catalogReadOnly';
import React,{Suspense,lazy} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { captureMobileViewport } from './utils/mobileViewportDebug';
import { ThemeProvider, initializeTheme } from './components/config/theme';
import {shortDocumentPattern} from './utils/documentShortCode';
import './i18n/index';
import {prefetchDocument} from './api/documentPrefetch';
import { installImageDragGuard } from './components/interaction/lists';
import { applySiteIdentity } from './utils/siteIdentity';
import { installDevelopmentErrorOverlayFilter } from './utils/developmentErrorOverlay';
import { initSafeAreaCSS,installPageZoomGuard } from './components/interaction/runtime';
import {isEntryQueueDiagnosticPath} from './features/erp/productEntryStorage';
const App=lazy(()=>import('./App'));
const DocumentApp=lazy(()=>import('./projects/erp/DocumentApp'));
const EntryQueueDiagnostics=lazy(()=>import('./projects/erp/EntryQueueDiagnostics'));
const diagnostic=isEntryQueueDiagnosticPath(window.location.pathname);
const documentCode=window.location.pathname.match(shortDocumentPattern)?.[1];

if(!diagnostic){
if(documentCode)prefetchDocument();
installDevelopmentErrorOverlayFilter();

// Initialize safe area CSS based on browser detection
initSafeAreaCSS();
installPageZoomGuard();
captureMobileViewport();
installImageDragGuard();
initializeTheme();
applySiteIdentity(window.location.pathname);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  //   <React.StrictMode>
  <ThemeProvider><Suspense fallback={null}>{diagnostic?<EntryQueueDiagnostics/>:documentCode?<DocumentApp code={documentCode}/>:<App/>}</Suspense></ThemeProvider>,
  //   </React.StrictMode>,
);
